import React from "react";
import styled from "styled-components";

const InputRequestStyle = styled.div`
  width: 100%;
  background-color: green;
  display: inline-block;
`;

const InputTextStyle = styled.input`
  width: 75%;
`;

const InputRequest = ({ defaultValue }) => {
  return (
    <InputRequestStyle>
      <InputTextStyle type="text" defaultValue={defaultValue}></InputTextStyle>
      <button>Save</button>
    </InputRequestStyle>
  );
};

export default InputRequest;
